import { useRef } from 'react';

export const REQUEST_ABORTED_ON_RESET_REASON = 'Request aborted after state reset';

// need to check for both the message and the name because of different implementation of AbortController in different browsers (chrome vs firefox)
export const isAbortError = (error: Error | undefined) =>
    error?.message === REQUEST_ABORTED_ON_RESET_REASON || error?.name === 'AbortError';

export const useAbortController = () => {
    const abortController = useRef<AbortController>(new AbortController());
    const resetAbortController = () => {
        abortController.current.abort(REQUEST_ABORTED_ON_RESET_REASON);
        abortController.current = new AbortController();
    };
    return {
        abortController: abortController.current,
        resetAbortController,
    };
};
